/**
 * UranIA PA — striscia istituzionale blu (slim header AgID-style).
 *
 * Banner globale renderizzato sopra all'``AppTopbar`` su tutte le pagine.
 * Identifica l'ente di appartenenza del pilota (Regione Siciliana · AdG
 * FESR/FSE+) e il programma operativo. Pattern Bootstrap Italia
 * ``it-header-slim``.
 */

import { useTranslation } from 'react-i18next';
import type { JSX } from 'react';

export function InstitutionalBanner(): JSX.Element {
  const { t } = useTranslation();
  return (
    <div
      className="it-header-slim-wrapper"
      style={{ backgroundColor: '#06c' }}
      role="region"
      aria-label={t('institutional_banner.aria_label')}
      data-testid="institutional-banner"
    >
      <div className="container-fluid">
        <div className="d-flex align-items-center justify-content-between text-white py-1 small">
          <span data-testid="institutional-banner-ente">
            {t('institutional_banner.ente')}
          </span>
          <span className="d-none d-md-inline opacity-75">
            {t('institutional_banner.programma')}
          </span>
        </div>
      </div>
    </div>
  );
}
